<template>
  <div></div>
</template>

<script>
import html2pdf from 'html2pdf.js';
import printJS from 'print-js';

/** Margen del PDF generado (html2pdf/jsPDF, unidad mm). No afecta las pantallas de la app. */
const PDF_PAGE_MARGIN_MM = 10; // 1 cm por lado

function escapeHtml(s) {
  if (s == null || s === '') return '';
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

export default {
  name: 'PrintWorkersReport',

  created() {
    this.$root.$on('print-workers-report-pdf', this.printPDF);
  },

  beforeDestroy() {
    this.$root.$off('print-workers-report-pdf', this.printPDF);
  },

  methods: {
    buildHtml(payload) {
      const numericColumn =
        typeof payload.totalColumnIndex === 'number'
          ? payload.totalColumnIndex
          : -1;
      const alignRight = index =>
        index === numericColumn ? 'text-align:right;' : '';

      const thead = payload.columnLabels
        .map(
          (label, index) =>
            `<th style="padding:6px 8px;border:1px solid #d9d9d9;background:#b71c1c;color:#fff;${alignRight(
              index
            )}">${escapeHtml(label)}</th>`
        )
        .join('');

      let tbody = '';
      if (payload.rows.length === 0) {
        const colspan = payload.columnLabels.length;
        tbody = `<tr><td colspan="${colspan}" style="padding:10px;border:1px solid #d9d9d9;text-align:center;">${escapeHtml(
          payload.emptyMessage
        )}</td></tr>`;
      } else {
        tbody = payload.rows
          .map((cells, rowIndex) => {
            const zebra = rowIndex % 2 === 1 ? 'background:#faf3f3;' : '';
            const tds = cells
              .map(
                (c, index) =>
                  `<td style="padding:5px 8px;border:1px solid #d9d9d9;${alignRight(
                    index
                  )}${zebra}">${escapeHtml(c)}</td>`
              )
              .join('');
            return `<tr>${tds}</tr>`;
          })
          .join('');
      }

      let tfoot = '';
      if (payload.totalValue != null && payload.rows.length > 0) {
        const total = numericColumn >= 0 ? numericColumn : 0;
        const labelSpan = Math.max(total, 1);
        const trailing = payload.columnLabels.length - labelSpan - 1;
        const trailingCells =
          trailing > 0
            ? `<td colspan="${trailing}" style="padding:8px;border:1px solid #d9d9d9;background:#f0e6e6;"></td>`
            : '';
        tfoot = `<tr>
          <td colspan="${labelSpan}" style="padding:8px;border:1px solid #d9d9d9;background:#f0e6e6;font-weight:bold;text-align:right;color:#b71c1c;">${escapeHtml(
          payload.totalLabel || 'Total'
        )}</td>
          <td style="padding:8px;border:1px solid #d9d9d9;background:#f0e6e6;font-weight:bold;text-align:right;color:#b71c1c;">${escapeHtml(
            payload.totalValue
          )}</td>
          ${trailingCells}
        </tr>`;
      }

      return `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8" />
  <style>
    body { font-family: Arial, Helvetica, sans-serif; font-size: 11px; color: #222; margin: 0; padding: 0; }
    h1 { font-size: 18px; color: #b71c1c; margin: 0 0 4px 0; }
    .subtitle { color: #666; font-size: 11px; margin: 0 0 10px 0; }
    .meta { margin: 3px 0; color: #333; }
    .header-band { border-bottom: 2px solid #b71c1c; padding-bottom: 8px; margin-bottom: 10px; }
    table { width: 100%; border-collapse: collapse; margin-top: 12px; }
    thead { display: table-header-group; }
    tr { page-break-inside: avoid; }
  </style>
</head>
<body>
  <div class="header-band">
    <h1>${escapeHtml(payload.title)}</h1>
    <p class="subtitle">${escapeHtml(payload.subtitle)}</p>
    <p class="meta">${escapeHtml(payload.workerLine)}</p>
    <p class="meta">${escapeHtml(payload.periodLine)}</p>
  </div>
  <table>
    <thead><tr>${thead}</tr></thead>
    <tbody>${tbody}</tbody>
    <tfoot>${tfoot}</tfoot>
  </table>
</body>
</html>`;
    },

    async printPDF(payload) {
      this.$root.$emit('workers-report-print-loading', true);
      try {
        const htmlData = this.buildHtml(payload);
        const safeName = (payload.fileName || 'ComisionTrabajador').replace(
          /[^\w-]/g,
          '_'
        );
        const opt = {
          margin: [
            PDF_PAGE_MARGIN_MM,
            PDF_PAGE_MARGIN_MM,
            PDF_PAGE_MARGIN_MM,
            PDF_PAGE_MARGIN_MM
          ],
          html2canvas: { scrollY: 0, scale: 2 },
          filename: `${safeName}.pdf`,
          jsPDF: {
            unit: 'mm',
            orientation: 'landscape',
            format: 'a4'
          },
          pagebreak: { mode: ['css', 'legacy'] }
        };
        const pdf = await html2pdf()
          .set(opt)
          .from(htmlData)
          .outputPdf();
        printJS({
          printable: btoa(pdf),
          type: 'pdf',
          base64: true
        });
      } catch (error) {
        console.error(
          'There was an error while generating workers report PDF' + error
        );
      } finally {
        this.$root.$emit('workers-report-print-loading', false);
      }
    }
  }
};
</script>
